import { useQuery } from '@tanstack/react-query';
import { getGoogleWorkspaceStatus } from '../api';

export function useGoogleWorkspaceConnected(companyId) {
  const query = useQuery({
    queryKey: ['google-workspace-status', companyId],
    queryFn: () => getGoogleWorkspaceStatus(companyId),
    enabled: !!companyId,
    staleTime: 30 * 1000,
  });
  return query.data?.is_connected === true;
}
